/**
 * Formats a backend timestamp into "Mmm D, YYYY HH:MM" in the user's local timezone
 * (uses getHours/getMinutes, not UTC).
 * @param {string} dateStr - Backend date string (e.g. "2019-03-21 21:35:03")
 * @param {string} [lang='en'] - Locale for the short month name
 * @returns {string}
 */
const formatLocalDateTime = (dateStr, lang = 'en') => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return '';
    const month = date.toLocaleString(lang || 'en', { month: 'short' });
    const day = date.getDate();
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${month} ${day}, ${year} ${hours}:${minutes}`;
};

export default formatLocalDateTime;
